/* eslint-disable import/no-named-as-default */
/* eslint-disable no-undef */

import { useContext, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ModalGeneric } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

import { applyMSDSTemplate, postApplyTemplate } from '../../../services/templateWorkReport';
import LoaderContext from '../../../context/LoaderProvider';
import ManageTemplate from '../../../page/ManageTemplate/ManageTemplate';
import useToast from '../../../hooks/useToast';
import { formatFullDate, formatsEnum } from '../../../utils/formatUtils';
import { useWorkReportModals } from '../../../context/WorkReportModalsContext';

import DateRange from './DateRange';
import './TemplateWorkReportModal.scss';
// Cambiar los step numerales por esto que es mas entendible
const stepsApplyModal = {
  grid: 1,
  infoApplyModal: 2
};

const TemplateWorkReportModal = ({
  show,
  onHide,
  onAccept,
  monthly,
  applied,
  contractNumber,
  disabledEditStateCancelOrFinish,
  endingDate,
  initialDate,
  isOyM
}) => {
  const [checkBoxState, setCheckBoxState] = useState([]);
  const [itemCheck, setItemCheck] = useState([]);
  const [canApply, setCanApply] = useState(true);
  const [infoModal, setInfoModal] = useState();
  const [workReportTemplateId, setWorkReportTemplateId] = useState(null);
  const [step, setStep] = useState(1);
  const [modalDeleteHide, setModalDeleteHide] = useState(true);
  const [withAmount, setWithAmount] = useState(false);
  const [dateRanges, setDateRanges] = useState([]);
  const firstDay = initialDate;
  const lastDay = endingDate;

  const isInConfimationApplyStep = step === stepsApplyModal.infoApplyModal;
  const isInGridStep = step === stepsApplyModal.grid;

  const { setLoader } = useContext(LoaderContext);
  const { setNewToast } = useToast();
  const { id } = useParams();
  const location = useLocation();
  const { activeReplaceLinesSuccessModal, closeModalByName } = useWorkReportModals();
  const closeModal = () => {
    if (!canApply && isInConfimationApplyStep && !monthly) {
      onAccept();
    }
    setStep(stepsApplyModal.grid);
    setCanApply(true);
    setInfoModal({
      cuerpo: '',
      titulo: ''
    });
    setDateRanges([]);
    closeModalByName('templateWorkReportModal');
  };

  const handleSecondaryAction = () => {
    setStep(stepsApplyModal.grid);
  };

  const handleAfterPostApplyTemplate = (hayPosicionesLineasReemplazadas = false) => {
    if (hayPosicionesLineasReemplazadas === false) {
      setStep(stepsApplyModal.infoApplyModal);
    } else {
      setStep(stepsApplyModal.activeReplaceLinesSuccessModal);
    }
  };

  const handleDateAdapter = (dates) =>
    dates?.map((date) => ({ desde: date?.startDate, hasta: date?.finalDate }));

  // Confirm applying a template for a regular request
  const handleFinallyApply = async () => {
    try {
      setLoader(true);
      const body = handleDateAdapter(dateRanges);
      const response = await postApplyTemplate(workReportTemplateId, id, true, body);
      // If it can be applied successfully, show the success message
      // Otherwise, go to step 3 to show the
      // message indicating the template cannot be applied

      if (response?.aplicado) {
        if (response?.hayPosicionesLineasReemplazadas === false) {
          setNewToast({
            type: 'SUCCESS',
            message: response.cuerpo
          });
        } else {
          activeReplaceLinesSuccessModal({ reemplazoDeLinea: response });
        }
        setStep(stepsApplyModal.grid);
        onAccept();
        closeModal();
      }
      setLoader(false);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
      closeModal();
      setLoader(false);
    }
  };

  // First attempt/step of applying a template
  // for a regular request
  const handleApplyTemplate = async () => {
    try {
      setLoader(true);
      const body = handleDateAdapter(dateRanges);
      const response = await postApplyTemplate(workReportTemplateId, id, false, body);

      setCanApply(response?.validoParaAplicar);
      const auxInfoModal = {
        cuerpo: response?.cuerpo,
        titulo: response?.titulo
      };

      setInfoModal(auxInfoModal);
      if (response?.hayPosicionesLineasReemplazadas === false) {
        handleAfterPostApplyTemplate();
      } else {
        closeModalByName('templateWorkReportModal');
        activeReplaceLinesSuccessModal({ reemplazoDeLinea: response });
        handleFinallyApply();
      }
      setLoader(false);
    } catch (error) {
      onHide();
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
      setLoader(false);
    }
  };

  // Confirm applying a template for a monthly request
  // This should open the locations modal with the date ranges
  // const handleFinallyMonthlyApply = async () => {
  //   try {
  //     setLoader(true);
  //     closeModal();
  //     setAddUbicationToPl(workReportTemplateId);

  //     setLoader(false);
  //   } catch (error) {
  //     setNewToast({
  //       type: 'ERROR',
  //       message: error.message
  //     });
  //     closeModal();
  //     setLoader(false);
  //   }
  // };

  const handleApplyMSDSTemplate = () => {
    setLoader(true);
    const body = handleDateAdapter(dateRanges);

    applyMSDSTemplate({ id: workReportTemplateId, idSolicitud: id }, body)
      .then((response) => {
        onAccept();
        if (response?.hayPosicionesLineasReemplazadas === false) {
          setNewToast({ type: 'SUCCESS', message: response.cuerpo });
        } else {
          activeReplaceLinesSuccessModal({ reemplazoDeLinea: response });
        }
      })
      .catch((error) => setNewToast({ type: 'ERROR', message: error.message }))
      .finally(() => {
        setLoader(false);
        closeModal();
      });
  };

  // First step to apply a template for a monthly request
  // when calling this function the AddUbicationToPL modal should be set
  // so that it serves to apply a template
  // const handleApplyTemplateMonthly = async () => {
  //   try {
  //     setLoader(true);
  //     const response = await postMonthlyApplyTemplate(workReportTemplateId, id, false, {
  //       numeroContrato: 0,
  //       idUbicacion: [],
  //       lineas: []
  //     });

  //       setInfoModal(auxInfoModal);
  //       setStep(stepsApplyModal.infoApplyModal);
  //     } else {
  //       handleFinallyMonthlyApply();
  //     }
  //     setLoader(false);
  //   } catch (error) {
  //     onHide();
  //     setNewToast({
  //       type: 'ERROR',
  //       message: error.message
  //     });
  //     setLoader(false);
  //   }
  // };

  const handlePrimaryAction = () => {
    if (!canApply) return closeModal();
    // Primary actions for monthly request detail
    if (monthly) return handleApplyMSDSTemplate();

    // Primary actions for request detail
    if (isInGridStep) return handleApplyTemplate();
    if (isInConfimationApplyStep) return handleFinallyApply();

    return closeModal();
    // }
  };

  const secondayActionLabel = () => {
    if (!canApply && isInConfimationApplyStep) return '';
    if (isInGridStep) return 'Salir';

    return 'Cancelar';
  };

  useEffect(() => {
    if (checkBoxState.length === 1) {
      setWorkReportTemplateId(itemCheck[0].id);
    }
  }, [checkBoxState.length, itemCheck]);

  useEffect(() => {
    if (applied) {
      closeModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applied]);
  useEffect(() => {
    if (firstDay && show) {
      const initialDateRanges = [{ startDate: firstDay, finalDate: lastDay, ubicationId: id }];

      setDateRanges(initialDateRanges);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const getStartDateOfNewRange = (ubicationId) => {
    const ranges = dateRanges.filter((range) => range.ubicationId === ubicationId);

    const lastRange = ranges[ranges.length - 1];

    const dateToReturn = new Date(lastRange?.finalDate || lastRange.startDate);
    const nextDate = new Date(
      dateToReturn.getFullYear(),
      dateToReturn.getUTCMonth(),
      dateToReturn.getUTCDate() + 1
    );

    return formatFullDate(nextDate, formatsEnum.FORMAT_DATE_2);
  };

  const handleAddRange = (ubicationId) => {
    const dateRangeToAdd = {
      ubicationId,
      startDate: getStartDateOfNewRange(ubicationId),
      finalDate: lastDay
    };

    const newDatesRanges = [...dateRanges, dateRangeToAdd];

    setDateRanges(newDatesRanges);
  };

  const handleSuprRange = (ubicationIndex) => {
    const newDateRanges = dateRanges.filter((_, index) => index !== ubicationIndex);

    setDateRanges(newDateRanges);
  };

  const getUbicationDateRanges = (ubicationId) =>
    dateRanges.filter((dateRange) => dateRange.ubicationId === ubicationId);

  const disableAddButton = (ubicationId) => {
    const filteredRanges = getUbicationDateRanges(ubicationId);

    return filteredRanges.some((range) => range.finalDate === lastDay);
  };

  const handleChangeStartDate = (value, index) => {
    const updatedDateRanges = dateRanges.map((dateRange, i) => {
      if (i === index) {
        return {
          ...dateRange,
          startDate: value,
          finalDate: ''
        };
      }

      return dateRange;
    });

    setDateRanges(updatedDateRanges);
  };

  const handleChangeFinalDate = (value, index) => {
    const updatedDateRanges = dateRanges.map((dateRange, i) => {
      if (i === index) {
        return {
          ...dateRange,
          finalDate: value
        };
      }

      return dateRange;
    });

    setDateRanges(updatedDateRanges);
  };

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={closeModal}
      primaryAction={handlePrimaryAction}
      primaryActionDisabled={checkBoxState.length !== 1 || disabledEditStateCancelOrFinish}
      primaryActionLabel={
        !canApply && isInConfimationApplyStep ? 'Entendido' : 'Aplicar Plantillas'
      }
      primaryActionVariant="primary"
      secondaryAction={isInGridStep ? onHide : handleSecondaryAction}
      secondaryActionLabel={secondayActionLabel()}
      show={show}
      size="xl"
      title={isInGridStep ? 'Plantillas' : 'Aplicar Plantillas'}
      variantHeader={modalDeleteHide ? 'info' : 'info hide-modal-template'}
    >
      <>
        <div className="modal_template_error">
          <span>
            <b
              style={{
                color: `${isInConfimationApplyStep ? '#ff6666' : '#3865b8'}`
              }}
            >
              {(infoModal?.cuerpo?.length || infoModal?.titulo?.length) &&
              isInConfimationApplyStep ? (
                <>
                  {!canApply && <p>{infoModal?.cuerpo}</p>}
                  {canApply && (
                    <>
                      {infoModal?.titulo}
                      <br />
                      {infoModal?.cuerpo}
                    </>
                  )}
                </>
              ) : (
                <>
                  Selecciona una de las plantillas para aplicar las posiciones y líneas guardadas
                  <br />O genera una plantilla en base a las posiciones y líneas agregadas en
                  la&nbsp;
                  {monthly ? 'MSDS' : 'SDS'}
                </>
              )}
            </b>
          </span>
        </div>
        <hr />
        <ManageTemplate
          applyTemplateView
          checkBoxState={checkBoxState}
          contractNumber={contractNumber}
          idRequest={id}
          isSDS={{
            isSDS: !monthly,
            pathname: location.pathname,
            contractNumber
          }}
          itemCheck={itemCheck}
          monthly={monthly}
          setCheckBoxState={setCheckBoxState}
          setItemCheck={setItemCheck}
          setModalDeleteHide={setModalDeleteHide}
          setWithAmount={setWithAmount}
          viewWithOutCheckBox={isInConfimationApplyStep}
          withAmount={withAmount}
        />
        {monthly && !isOyM ? (
          <div className="data-range-header-warning">
            <span>
              {' '}
              Se aplicarán únicamente las ubicaciones cuyos eventos correspondan a los tipos de
              eventos de la solicitud.
            </span>
          </div>
        ) : null}
        {withAmount && (
          <>
            <p className="data-range-header-warning">
              No se copiarán las cantidades en los días que la ventana de notificación se encuentre
              bloqueada
            </p>
            {dateRanges.length > 0 &&
              dateRanges.map((dateRange, index) => (
                <DateRange
                  disableAddButton={disableAddButton(dateRange.ubicationId)}
                  disableSuprButton={getUbicationDateRanges(dateRange.ubicationId).length === 1}
                  finalDate={dateRange.finalDate}
                  handleAddRange={handleAddRange}
                  handleSuprRange={handleSuprRange}
                  id={dateRange.ubicationId}
                  index={index}
                  key={dateRange?.startDate.toString()}
                  max={lastDay}
                  min={index === 0 ? firstDay : dateRange.startDate}
                  onChangeFinalDate={handleChangeFinalDate}
                  onChangeStartDate={handleChangeStartDate}
                  startDate={dateRange.startDate}
                />
              ))}
          </>
        )}
      </>
    </ModalGeneric>
  );
};

export default TemplateWorkReportModal;

TemplateWorkReportModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onAccept: PropTypes.func,
  monthly: PropTypes.bool,
  contractNumber: PropTypes.number,
  applied: PropTypes.bool,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  endingDate: PropTypes.string,
  initialDate: PropTypes.string,
  isOyM: PropTypes.bool
};

TemplateWorkReportModal.defaultProps = {
  show: false,
  onHide: () => {
    /* Empty */
  },
  onAccept: () => {
    /* Empty */
  },
  monthly: false,
  // setShowAddUbicationsToPLModal: () => {},
  // setApplyTemplateView: () => {},
  // setTemplateId: () => {},
  applied: false,
  contractNumber: undefined,
  endingDate: '',
  initialDate: '',
  isOyM: false
};
